/**
 * EL NOMBRE QUE VA ARRIBA ES EL DEL NEGOCIO (12-oct-2026).
 *
 * Kervens: «a partir de hoy, Conversia no se llama Conversia… allá arriba, donde dice
 * Conversia, vas a poner el nombre del negocio del cliente». El sistema no se nombra en el
 * panel: se ve el negocio, con su sello y con una estética que vaya con lo que representa.
 */

/** Sin negocio activo (antes de entrar, o la administración sin elegir uno) arriba va Silva Notion, la casa que opera este panel. */
export const NEGOCIO = 'Silva Notion';

/** Las iniciales del negocio para su sello: «Rich Real Estate» → «RR». PURO. */
export function inicialesDe(nombre: string): string {
  const palabras = nombre.trim().split(' ').filter(Boolean);
  // La primera letra (o cifra) de cada palabra: «Conversia (admin)» → «CA», no «C(».
  const letras = palabras.map((p) => p.match(/[\p{L}\p{N}]/u)?.[0]).filter(Boolean);
  return (letras.slice(0, 2).join('') || '·').toUpperCase();
}
